import React from 'react';
import PropTypes from 'prop-types';
import ImageSvg from '../image/ImageSvg';

const icons = {
  left: 'arrowleftlarge',
  right: 'arrowrightlarge',
  up: 'arrowup',
  down: 'arrowdown',
};

const SliderArrow = React.forwardRef((props, ref) => (
  // eslint-disable-next-line jsx-a11y/anchor-is-valid
  <a
    href="#"
    ref={ref}
    onClick={props.onClick}
    className={props.className}
    style={props.style}
  >
    <ImageSvg svg={`icon-${icons[props.type]}`} />
  </a>
));

SliderArrow.propTypes = {
  type: PropTypes.oneOf(['left', 'right', 'up', 'down']).isRequired,
  onClick: PropTypes.func,
  className: PropTypes.string,
  style: PropTypes.instanceOf(Object),
};

SliderArrow.defaultProps = {
  onClick: null,
  className: '',
  style: null,
};

export default SliderArrow;
